import { render, staticRenderFns } from "./LinkedinChannels.vue?vue&type=template&id=5077d722&scoped=true"
import script from "./LinkedinChannels.vue?vue&type=script&lang=js"
export * from "./LinkedinChannels.vue?vue&type=script&lang=js"
import style0 from "./LinkedinChannels.vue?vue&type=style&index=0&id=5077d722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5077d722",
  null
  
)

export default component.exports